import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { buildTypedMessageTree, type MessageTree } from './messageTree';

interface FormattedArrayProps<TValue extends MessageTree> {
  id: string;
  children: (value: TValue) => ReactNode;
}

export function FormattedArray<TValue extends MessageTree>({ id, children }: FormattedArrayProps<TValue>) {
  const intl = useIntl();
  const translatedValue = buildTypedMessageTree<TValue>((intl.messages ?? {}) as Record<string, unknown>, id);

  if (translatedValue === undefined) {
    return null;
  }

  return <>{children(translatedValue)}</>;
}
